var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quicklink-menu",attrs:{"id":"quicklinkMenu"}},[_c('nested-menu',{ref:"nestedMenu",staticStyle:{"position":"absolute"},attrs:{"isroot":true,"parentexpanded":false},on:{"onclick":_vm.doClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-149c185e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procedure/procedure-quicklink-menu.vue
// module id = 1205
// module chunks = 0